/**
 * Listing Title DOM Component
 *
 * Creates and manages the H1 title element for the listing sheet panel.
 * Text is set by the owning plugin; this component owns no state.
 *
 * @module nativeInteractiveSiteMap/components/listingTitle.dom
 */

export default function createListingTitle() {
  const element = document.createElement('h1');
  element.className = `nhs-c-native-interactive-site-map__panel-title nhs-mq-native-interactive-site-map__panel-title-medium`;

  return {
    getElement() {
      return element;
    },
    setText(text) {
      element.textContent = text;
    },
    remove() {
      element.remove();
    },
  };
}
